import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './CompanyListItem.css';

class CompanyListItem extends React.Component {
  static propTypes = {
    to: PropTypes.string,
    name: PropTypes.string,
    logo: PropTypes.string,
    size: PropTypes.string,
    industry: PropTypes.string,
    status: PropTypes.string
  };

  render() {
    const { to, name, logo, size, industry, status } = this.props;

    return (
      <Link className='CompanyListItem-root' to={to}>
        <div className='CompanyListItem-text'>
          <h2>{name}</h2>       
          <p>
            {size ? `${size[0].toUpperCase() + size.slice(1)}` : 'Get started here'}
            {industry ? ` | ${industry[0].toUpperCase() + industry.slice(1)}` : ''}
            {status ? ` | ${status[0].toUpperCase() + status.slice(1)}` : ''}
          </p>
        </div>
        <div className='CompanyListItem-logo'>
          {logo && <img src={logo} alt='' />}
        </div>
      </Link>
    );
  }
}

export default CompanyListItem;


// WEBPACK FOOTER //
// ./src/components/companies/CompanyListItem/CompanyListItem.js